import React from "react";
import SectionHeader from "./SectionHeader";
import SpecList from "../list/SpecList";
import * as CompareSectionStyles from "../styles/CompareSection";
import useEngineSpecs from "../../../hooks/useEngineSpecs";
import useDisplayOptions from "../../../hooks/useDisplayOptions";
import { useCompareV2Selector } from "../../../redux/store";

export type EngineSpecsPropTypes = {
    isPdf?: boolean;
};

const EngineSpecs = ({ isPdf }: EngineSpecsPropTypes): JSX.Element | null => {
    const commonSettings = useCompareV2Selector((state) => state.commonSettings);
    const { availableEngineSpecs, additionalEngineSpecs, openAllSpecsEngines, setOpenAllSpecsEngines } =
        useEngineSpecs(isPdf);
    const { onlyShowDiff, setOnlyShowDiff, showDiffToggle } = useDisplayOptions("Engine");

    const specListProps = {
        cultureName: commonSettings.culture.name,
        isMessageLabel: false,
        onlyShowDifferences: onlyShowDiff,
        showAllSpecs: openAllSpecsEngines,
        showPrices: commonSettings.showPrice,
        isPdf,
    };

    return (
        <CompareSectionStyles.Wrapper mt={4} mb={4}>
            <SectionHeader
                isPdf={isPdf}
                title="compareBodyEngineSpecsTitle"
                setOnlyShowDifferences={setOnlyShowDiff}
                onlyShowDifferences={onlyShowDiff}
                description="compareBodyEngineSpecsInfo"
                showToggleDifferences={showDiffToggle}
                toggleShowAllSpecs={setOpenAllSpecsEngines}
                showAllSpecs={openAllSpecsEngines}
            />

            <SpecList specs={availableEngineSpecs} {...specListProps} />
            <SpecList title="compareBodyAdditionalSpecs" specs={additionalEngineSpecs} {...specListProps} />
        </CompareSectionStyles.Wrapper>
    );
};

export default EngineSpecs;
